require("core-js/modules/es6.array.map");

module.exports = function (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];

  for (var i = 0; i < xs.length; i++) {
    var x = xs[i];
    if (hasOwn.call(xs, i)) res.push(f(x, i, xs));
  }

  return res;
};

var hasOwn = Object.prototype.hasOwnProperty;